import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('tags', storeModule.createStoreModule('tags'))
